import React, { useEffect, useState } from "react";
import "./listing-project.css";
import LoaderHelper from "../../../customComponents/Loading/LoaderHelper";
import { alertErrorMessage, alertSuccessMessage } from "../../../customComponents/CustomAlertMessage";
import AuthService from "../../../api/services/AuthService";
import { Helmet } from "react-helmet-async";
import Footer from "../../../customComponents/Footer";

const ListCoin = () => {
    // Form state variables
    const [projectName, setProjectName] = useState("");
    const [contactName, setContactName] = useState("");
    const [telegramId, setTelegramId] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [emailAddress, setEmailAddress] = useState("");
    const [referredBy, setReferredBy] = useState("");
    const [comments, setComments] = useState("");
    const [contractAddress, setContrectAddress] = useState("");
    const [countryCode, setCountryCode] = useState("91");

    // Modal visibility state
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // Form submission handler
    const handleAddCoin = async (e) => {
        if (e) e.preventDefault();
        if (!projectName || !contactName || !phoneNumber || !emailAddress || !telegramId || !contractAddress) {
            alertErrorMessage("Please fill out all required fields before submitting.");
            return;
        }
        LoaderHelper.loaderStatus(true);
        await AuthService.assetAddList(
            projectName,
            contactName,
            telegramId,
            phoneNumber,
            emailAddress,
            referredBy,
            comments,
            countryCode,
            contractAddress
        ).then(async (result) => {
            if (result?.success) {
                LoaderHelper.loaderStatus(false);
                try {
                    alertSuccessMessage(result?.message || "Application submitted successfully!");
                    setProjectName("");
                    setContactName("");
                    setTelegramId("");
                    setPhoneNumber("");
                    setEmailAddress("");
                    setReferredBy("");
                    setComments("");
                    setContrectAddress("");
                    setIsModalOpen(false);
                } catch (error) {
                    alertErrorMessage(error);
                }
            } else {
                LoaderHelper.loaderStatus(false);
                alertErrorMessage(result?.message || "Failed to submit application.");
            }
        });
    };

    const openModal = () => {
        setIsModalOpen(true);
    };

    return (
        <>
            <Helmet>
                <title>Coin List | Supported Cryptocurrencies on AGCX </title>

                <meta
                    name="description"
                    content="Browse all cryptocurrencies and trading pairs available on AGCX, including live prices, spot markets, and newly listed tokens."
                />

                <meta
                    name="keywords"
                    content="crypto coins listed, supported cryptocurrencies, trading pairs AGCX "
                />
                <link rel="canonical" href="https://arabglobal.ae/coin_list" />
            </Helmet>

            <div className="listing-project-page">
                {/* --- Ambient Background Blur Blobs --- */}
                <div className="bg-blur-glow glow-top-left"></div>
                <div className="bg-blur-glow glow-middle-right"></div>
                <div className="bg-blur-glow glow-middle-left"></div>
                <div className="bg-blur-glow glow-bottom-right"></div>

                <div className="listing-project-container">

                    {/* ========================================== */}
                    {/* --- 1. HERO SECTION --- */}
                    {/* ========================================== */}
                    <div className="listing-hero">
                        <div className="listing-hero-content">
                            <span className="listing-hero-subtitle">Listing Applications</span>
                            <h1 className="listing-hero-title">
                                Launch Your Project <span className="gold-text">On AGCX</span>
                            </h1>
                            <p className="listing-hero-desc">
                                AGCX empowers innovative blockchain projects by providing a robust, transparent, and high-liquidity platform for growth and global exposure.
                            </p>
                            <button className="listing-apply-btn" onClick={openModal}>
                                Apply for Listing
                            </button>
                        </div>
                        <div className="cta-banner-image">
                            <img
                                src="/images/listing-project-img/project_agce_img.png"
                                alt="Ready to Launch Your Project?"
                            />
                        </div>
                    </div>


                    {/* ========================================== */}
                    {/* --- 2. AGCX LISTING PROCESS SECTION --- */}
                    {/* ========================================== */}
                    <div className="listing-process-section">
                        <div className="section-header">
                            <span className="section-subtitle">Our Process</span>
                            <h2 className="section-title">AGCX Listing Process</h2>
                        </div>

                        <div className="process-grid">
                            {/* Step 1 */}
                            <div className="process-card">
                                <div className="step-badge">1</div>
                                <div className="process-icon">
                                    <img
                                        src="/images/listing-project-img/listing_process_img.png"
                                        alt="Submit Application"
                                    />
                                </div>
                                <h3>Submit Application</h3>
                                <p>Fill out the listing application form with your project details and required documents.</p>
                            </div>

                            {/* Step 2 */}
                            <div className="process-card">
                                <div className="step-badge">2</div>
                                <div className="process-icon">
                                    <img
                                        src="/images/listing-project-img/listing_process_img2.png"
                                        alt="Evaluation"
                                    />
                                </div>
                                <h3>Evaluation</h3>
                                <p>AGCX team will assess your project based on our listing criteria and conduct an assessment.</p>
                            </div>

                            {/* Step 3 */}
                            <div className="process-card">
                                <div className="step-badge">3</div>
                                <div className="process-icon">
                                    <img
                                        src="/images/listing-project-img/listing_process_img3.png"
                                        alt="Discussion & Review"
                                    />
                                </div>
                                <h3>Discussion & Review</h3>
                                <p>Selected projects are invited for further discussion and project assessment.</p>
                            </div>

                            {/* Step 4 */}
                            <div className="process-card">
                                <div className="step-badge">4</div>
                                <div className="process-icon">
                                    <img
                                        src="/images/listing-project-img/listing_process_img4.png"
                                        alt="Listing Approval"
                                    />
                                </div>
                                <h3>Listing Approval</h3>
                                <p>Approved projects will be listed on AGCX and gain global exposure.</p>
                            </div>
                        </div>
                    </div>


                    {/* ========================================== */}
                    {/* --- 3. WHY LIST WITH US / FEATURES SECTION --- */}
                    {/* ========================================== */}
                    <div className="listing-features-section">
                        {/* Row 1: 4 Cards */}
                        <div className="features-grid grid-4">
                            {/* Feature 1 */}
                            <div className="feature-card">
                                <div className="feature-icon">
                                    <img
                                        src="/images/listing-project-img/listing_process_img5.png"
                                        alt="Trusted & Secure"
                                    />
                                </div>
                                <h3>Trusted & Secure</h3>
                                <p>AGCX ensures a safe trading environment with verified projects and rigorous listing standards.</p>
                            </div>

                            {/* Feature 2 */}
                            <div className="feature-card">
                                <div className="feature-icon">
                                    <img
                                        src="/images/listing-project-img/listing_process_img6.png"
                                        alt="High Liquidity"
                                    />
                                </div>
                                <h3>High Liquidity</h3>
                                <p>Access deep liquidity pools and a highly active global trading community.</p>
                            </div>

                            {/* Feature 3 */}
                            <div className="feature-card">
                                <div className="feature-icon">
                                    <img
                                        src="/images/listing-project-img/listing_process_img7.png"
                                        alt="Global Exposure"
                                    />
                                </div>
                                <h3>Global Exposure</h3>
                                <p>Reach millions of investors and traders across every continent worldwide.</p>
                            </div>

                            {/* Feature 4 */}
                            <div className="feature-card">
                                <div className="feature-icon">
                                    <img
                                        src="/images/listing-project-img/listing_process_img8.png"
                                        alt="Marketing Support"
                                    />
                                </div>
                                <h3>Marketing Support</h3>
                                <p>Get dedicated marketing and community support to grow your project.</p>
                            </div>
                        </div>

                        {/* Row 2: 3 Cards */}
                        <div className="features-grid grid-3">
                            {/* Feature 5 */}
                            <div className="feature-card">
                                <div className="feature-icon">
                                    <img
                                        src="/images/listing-project-img/listing_process_img9.png"
                                        alt="Post-Listing Support"
                                    />
                                </div>
                                <h3>Post-Listing Support</h3>
                                <p>AGCX continues to provide support with market making, liquidity, and ongoing visibility.</p>
                            </div>

                            {/* Feature 6 */}
                            <div className="feature-card">
                                <div className="feature-icon">
                                    <img
                                        src="/images/listing-project-img/listing_process_img10.png"
                                        alt="Scam Prevention"
                                    />
                                </div>
                                <h3>Scam Prevention</h3>
                                <p>AGCX has strict anti-fraud policies to protect users from fraudulent listing applications.</p>
                            </div>

                            {/* Feature 7 */}
                            <div className="feature-card">
                                <div className="feature-icon">
                                    <img
                                        src="/images/listing-project-img/listing_process_img11.png"
                                        alt="Ethics & Transparency"
                                    />
                                </div>
                                <h3>Ethics & Transparency</h3>
                                <p>We uphold principles of fairness, ethics, and full transparency throughout the listing process.</p>
                            </div>
                        </div>
                    </div>


                    {/* ========================================== */}
                    {/* --- 4. CALL TO ACTION BANNER SECTION --- */}
                    {/* ========================================== */}
                    <div className="listing-cta-banner">
                        <div className="cta-banner-content">
                            <span className="cta-subtitle">Get Started</span>
                            <h2 className="cta-titlehome">Ready to Launch Your Project?</h2>
                            <p className="cta-desc">
                                Join AGCX and take your project to the next level. Apply now and get global exposure for your token.
                            </p>
                            <button className="listing-apply-btn" onClick={openModal}>
                                Apply Now <i className="ri-arrow-right-s-line"></i>
                            </button>
                        </div>

                        <div className="listing-hero-image">
                            <img
                                src="/images/listing-project-img/launch_project_vector.png"
                                alt="Launch Your Project On AGCX"
                            />
                        </div>
                    </div>

                </div>
            </div>

            {/* Application Modal Popup */}
            {isModalOpen && (
                <div className="listing-modal-overlay" onClick={() => setIsModalOpen(false)}>
                    <div className="listing-modal-content" onClick={(e) => e.stopPropagation()}>
                        <button className="modal-close-btn" onClick={() => setIsModalOpen(false)}>
                            <i className="ri-close-line"></i>
                        </button>
                        <div className="listing-form-header">
                            <h3>Apply for Listing</h3>
                            <p>Submit your project details to get started on AGCX.</p>
                        </div>
                        <form onSubmit={handleAddCoin} className="listing-form-grid">
                            <div className="form-field">
                                <label>Project Name *</label>
                                <input
                                    type="text"
                                    className="form-input"
                                    value={projectName}
                                    onChange={(e) => setProjectName(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="form-field">
                                <label>Smart Contract Address *</label>
                                <input
                                    type="text"
                                    className="form-input"
                                    value={contractAddress}
                                    onChange={(e) => setContrectAddress(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="form-field">
                                <label>Contact Name *</label>
                                <input
                                    type="text"
                                    className="form-input"
                                    value={contactName}
                                    onChange={(e) => setContactName(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="form-field">
                                <label>Telegram ID *</label>
                                <input
                                    type="text"
                                    className="form-input"
                                    value={telegramId}
                                    onChange={(e) => setTelegramId(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="form-field">
                                <label>Your Email Address *</label>
                                <input
                                    type="email"
                                    className="form-input"
                                    value={emailAddress}
                                    onChange={(e) => setEmailAddress(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="form-field">
                                <label>Referred by (Optional)</label>
                                <input
                                    type="text"
                                    className="form-input"
                                    value={referredBy}
                                    onChange={(e) => setReferredBy(e.target.value)}
                                />
                            </div>
                            <div className="form-field form-group-full">
                                <label>Phone Number *</label>
                                <div className="form-phone-group">
                                    <select
                                        className="form-input form-phone-code"
                                        value={countryCode}
                                        onChange={(e) => setCountryCode(e.target.value)}
                                    >
                                        <option value="91">+91 (IN)</option>
                                        <option value="1">+1 (US)</option>
                                        <option value="44">+44 (UK)</option>
                                        <option value="971">+971 (UAE)</option>
                                    </select>
                                    <input
                                        type="tel"
                                        className="form-input"
                                        value={phoneNumber}
                                        onChange={(e) => setPhoneNumber(e.target.value)}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="form-field form-group-full">
                                <label>Comments (Optional)</label>
                                <textarea
                                    className="form-input"
                                    rows="3"
                                    value={comments}
                                    onChange={(e) => setComments(e.target.value)}
                                ></textarea>
                            </div>
                            <button type="submit" className="form-submit-btn">
                                Send Application Request
                            </button>
                        </form>
                    </div>
                </div>
            )}

            <Footer />
        </>
    );
};

export default ListCoin;